import type { RouteObject } from 'react-router-dom';

import { AccountScreen } from 'common/accountActivationAndRecovery/AccountScreen';

import { DeviceHandoffLoginScreen } from './components/DeviceHandoffLoginScreen/DeviceHandoffLoginScreen';
import { DeviceHandoffScreenSegment } from './deviceHandoffScreenPaths';
import { ActivationRoute } from './routeElements/ActivationRoute';
import { CreatePasswordRoute } from './routeElements/CreatePasswordRoute';
import { ForgotUserRoute } from './routeElements/ForgotUserRoute';
import { PolicyRoute } from './routeElements/PolicyRoute';
import { SecurityAnswerRoute } from './routeElements/SecurityAnswerRoute';
import { SecurityQuestionRoute } from './routeElements/SecurityQuestionRoute';

export const deviceHandoffRoutes: RouteObject[] = [
    { index: true, element: <DeviceHandoffLoginScreen /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.ForgotUser], element: <ForgotUserRoute /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.SecurityQuestion], element: <SecurityQuestionRoute /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.SecurityAnswer], element: <SecurityAnswerRoute /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.CreatePassword], element: <CreatePasswordRoute /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.Activation], element: <ActivationRoute /> },
    { path: DeviceHandoffScreenSegment[AccountScreen.Policy], element: <PolicyRoute /> },
];
